// Hideo - application entry point (Vite).
// Styles are bundled here (Font Awesome and Tailwind come from npm). Then, before the Vue app exists, in this order: what
// happens while the app loads (loadApp: stores, saving listeners, file-drop guard, global shortcuts, the start at
// DOMContentLoaded), the names on window (src/globals.ts), the listeners of the @ menu and of the script editor's writing
// surface; then the Vue shell (App.vue) is mounted with Pinia and the router (docs/architecture.md, "Boot sequence").
// Font Awesome: the base, the solid icons and the brands (the regular style is not used: its font is not downloaded)
import '@fortawesome/fontawesome-free/css/fontawesome.min.css'
import '@fortawesome/fontawesome-free/css/solid.min.css'
import '@fortawesome/fontawesome-free/css/brands.min.css'
import './styles/legacy.css'
import './styles/tailwind.css'
// The app themes (src/features/appThemes.ts): their colour tokens and their rules, after Tailwind's so they win; nothing
// in them applies to Default
import './styles/theme-tokens.css'
import './styles/themes.css'
import { pinia } from './pinia'
import { loadApp } from './features/boot'
import { installGlobals } from './globals'
import { installMentions } from './features/mentionMenu'
import { installEditorSurface } from './features/editor/surface'
import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { useHomeStore } from './stores/home'

loadApp(document, window)
installGlobals(window)
// The document and window listeners of the "@" menu of the fields and of the script editor's writing surface, before the
// Vue components add theirs (docs/architecture.md, "Global keyboard shortcuts")
installMentions(document)
installEditorSurface(document, window)
createApp(App).use(pinia).use(router).mount('#app-shell')
// The clock of the Home box "To do and overdue" and of the Timeline (every minute and when returning to the app)
useHomeStore(pinia).startClock()
